var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"pa-0":"","fluid":""}},[_c('Introduction'),_c('MarketingPoints'),_c('LessonContents'),_c('FunctionList'),_c('AdultKidsTabs'),_c('MediaCoverage'),_c('FAQSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }